export default __webpack_public_path__ + "static/media/k_wdt_c_3_4.9a6480b0.mp3";